class MaxReducer {
  initialValue() {
    return null;
  }

  reduce(result, value) {
    if (result === null) {
      // First result
      return value;
    }

    return Math.max(result, value);
  }
}

export default MaxReducer;